// Mock data für KSV-Sportkantine

export const galleryImages = [
  { id: 1, url: 'https://cdn.website.dish.co/media/4b/e0/1383656/KSV-Sportkantine-ADD16DC2-0454-4222-83A7-86FD3C89FFC1.jpg', title: 'Willkommen in der Sportkantine' },
  { id: 2, url: 'https://cdn.website.dish.co/media/8c/de/1383662/KSV-Sportkantine-D687E2D2-5760-4755-A169-1B8BEA0B2DFD.jpg', title: 'Bar KSV Kantine' },
  { id: 3, url: 'https://cdn.website.dish.co/media/cf/2c/1383672/KSV-Sportkantine-CEABE031-E0B0-46AA-83B7-742282C28A80.jpg', title: 'KSV Kantine' },
  { id: 4, url: 'https://cdn.website.dish.co/media/3e/08/1338467/KSV-Sportkantine-8536CE71-5792-47F0-8422-73475C1A36E3.jpg', title: 'Sommersalat auf der Terrasse' },
  { id: 5, url: 'https://cdn.website.dish.co/media/86/2a/1338462/KSV-Sportkantine-A0091A1C-41C9-4871-B7BC-27001F1EAAA0.jpg', title: 'Martinigansl' },
  { id: 6, url: 'https://cdn.website.dish.co/media/ee/89/1368493/KSV-Sportkantine-C7C6406D-6587-4125-8478-D755C753A4F2.jpg', title: 'Heringsschmaus' },
  { id: 7, url: 'https://cdn.website.dish.co/media/d9/8d/1383651/KSV-Sportkantine-6C07194B-D00B-48AE-A481-4DBA32DD5EAB.jpg', title: 'Jour Dessert' },
  { id: 8, url: 'https://cdn.website.dish.co/media/36/2f/1368498/KSV-Sportkantine-9E88AE73-0620-4BFA-9EB9-A7FDCD2A99A1.jpg', title: 'Heringsschmaus' },
  { id: 9, url: 'https://cdn.website.dish.co/media/60/e8/1383687/KSV-Sportkantine-42BE5B72-05C0-441A-8CE9-DC4DFF69628C.jpg', title: 'Gemütliche Gastgartenparty' },
  { id: 10, url: 'https://cdn.website.dish.co/media/99/26/1404512/KSV-Sportkantine-0AE17D0C-BCDD-4912-AF01-07C41BE62521.jpg', title: 'Fingerfood' },
  { id: 11, url: 'https://cdn.website.dish.co/media/31/73/1404517/KSV-Sportkantine-807B0220-80AA-484F-8FB2-0E31598C5B24.jpg', title: 'Leckeres vom Holzkohlengrill' },
  { id: 12, url: 'https://cdn.website.dish.co/media/e1/f0/1404527/KSV-Sportkantine-5BE3E35A-67B3-4F5B-A2BA-0B5FBB33CE3C.jpg', title: 'Fingerfood' },
];

export const services = [
  { id: 1, icon: 'Accessibility', title: 'Barrierefrei', desc: 'Unser Lokal ist für alle leicht zugänglich.' },
  { id: 2, icon: 'Snowflake', title: 'Klimatisiert', desc: 'Angenehmes Klima zu jeder Jahreszeit.' },
  { id: 3, icon: 'Baby', title: 'Kinderecke', desc: 'Eine eigene Kinderecke für die Kleinsten.' },
  { id: 4, icon: 'TreePine', title: 'Außenbereich / Gastgarten', desc: 'Genießen Sie unseren gemütlichen Gastgarten.' },
  { id: 5, icon: 'Car', title: 'Parkplätze', desc: 'Eigene Parkplätze direkt vor dem Lokal.' },
  { id: 6, icon: 'PartyPopper', title: 'Private Veranstaltungen', desc: 'Ihre Feier bei uns – wir organisieren gerne.' },
  { id: 7, icon: 'ShoppingBag', title: 'Essen zum Mitnehmen', desc: 'Genießen Sie unsere Speisen auch zu Hause.' },
  { id: 8, icon: 'Heart', title: 'Hochzeiten', desc: 'Ihr besonderer Tag im festlichen Rahmen.' },
  { id: 9, icon: 'Wifi', title: 'Kostenloses WLAN', desc: 'Kostenloses Internet für alle Gäste.' },
  { id: 10, icon: 'PawPrint', title: 'Haustiere erlaubt', desc: 'Auch Ihre Vierbeiner sind bei uns willkommen.' },
];

export const paymentMethods = [
  { id: 1, icon: 'Banknote', name: 'Barzahlung', desc: 'Zahlung in bar direkt vor Ort.' },
  { id: 2, icon: 'CreditCard', name: 'Kartenzahlung', desc: 'Bezahlung mit Debit- und Kreditkarte möglich.' },
];

export const openingHours = [
  { day: 'Montag', hours: '09:00 – 23:00' },
  { day: 'Dienstag', hours: '09:00 – 23:00' },
  { day: 'Mittwoch', hours: '09:00 – 23:00' },
  { day: 'Donnerstag', hours: '09:00 – 23:00' },
  { day: 'Freitag', hours: '09:00 – 23:00' },
  { day: 'Samstag', hours: '09:00 – 23:00' },
  { day: 'Sonntag', hours: '09:00 – 13:00 (nur Bar)' },
];

export const kitchenHours = 'Mo – Sa 09:00 – 21:00';

export const contactInfo = {
  phone: '05012891563',
  email: 'info@ksvkantine.at',
  address: 'Otto-Herschmann-Gasse 6',
  city: '1110 Wien',
  country: 'Österreich',
};

export const heroImages = [
  'https://cdn.website.dish.co/media/4b/e0/1383656/KSV-Sportkantine-ADD16DC2-0454-4222-83A7-86FD3C89FFC1.jpg',
  'https://cdn.website.dish.co/media/3e/08/1338467/KSV-Sportkantine-8536CE71-5792-47F0-8422-73475C1A36E3.jpg',
  'https://cdn.website.dish.co/media/86/2a/1338462/KSV-Sportkantine-A0091A1C-41C9-4871-B7BC-27001F1EAAA0.jpg',
];

// Contact info shown across the site
